export default "__VITE_ASSET__CgnAkUfP__"